import React, {useState} from "react";
import {
    Button,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography
} from "@mui/material";
import {FileUploader} from "react-drag-drop-files";
import {SuittService} from "../../../services";
import {useNavigate, useParams} from "react-router-dom";
import {ErrorFallback, Page} from "../../../components";
import {ErrorBoundary} from "react-error-boundary";
import {snackActions} from "../../../utils/SnackBarUtils";
import {getBase64FromFile} from "utils";


// Разрешённые типы файлов (добавлен PDF)
const fileTypes = ["JPG", "PNG", "GIF", "PDF"];

function UserWorkAdd() {
    const initState = {
        name: "",
        type: "",
        output: "",
        volumeOfPages: "",
        coauthors: "",
        link: "",
        publishYear: new Date().getFullYear(),
        isScopus: false,
        isWoS: false,
        isCopernicus: false,
        image: null,
        group: ""
    };
    const suittService = new SuittService();
    const [work, setWork] = useState(initState);
    const {id: userId} = useParams();
    const navigate = useNavigate();

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        const splittedName = name.split(".");
        if (splittedName.length > 1) {
            setWork({
                ...work,
                [splittedName[0]]: {
                    ...work[splittedName[0]],
                    [splittedName[1]]: value
                }
            });
        } else {
            setWork({...work, [name]: value});
        }
    };

    const addUserWork = async () => {
        const result = await suittService.addUserWork({userId, data: work});
        if (!result || !result?.status) return snackActions.error("Щось пішло не так");

        setWork(initState);
        snackActions.success("Роботу успішно додано");
        navigate(`/cabinet/users/${userId}/edit`);
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Page title="Особистий профіль - додати працю" backTo={`/cabinet/users/${userId}/edit`}>
                <Grid container>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть назву роботи"}
                                label={"Назва роботи"}
                                variant="outlined"
                                fullWidth
                                value={work.name}
                                type={"string"}
                                name={"name"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть назву роботи"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть характер роботи"}
                                label={"Характер роботи"}
                                variant="outlined"
                                fullWidth
                                value={work.type}
                                type={"string"}
                                name={"type"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть характер роботи"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть вихідні дані"}
                                label={"Вихідні дані"}
                                variant="outlined"
                                fullWidth
                                value={work.output}
                                type={"string"}
                                name={"output"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть вихідні дані"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть обсяг (в сторінках)"}
                                label={"Обсяг (в сторінках)"}
                                variant="outlined"
                                fullWidth
                                value={work.volumeOfPages}
                                type={"number"}
                                name={"volumeOfPages"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть обсяг (в сторінках)"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть cпівавторів"}
                                label={"Співавтори"}
                                variant="outlined"
                                fullWidth
                                value={work.coauthors}
                                type={"string"}
                                name={"coauthors"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть cпівавторів"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть посилання"}
                                label={"Посилання"}
                                variant="outlined"
                                fullWidth
                                value={work.link}
                                type={"string"}
                                name={"link"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть посилання"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                placeholder={"Вкажіть рік публікації"}
                                label={"Рік публікації"}
                                variant="outlined"
                                fullWidth
                                value={work.publishYear}
                                type={"number"}
                                name={"publishYear"}
                                onChange={handleInputChange}
                                helperText={"Вкажіть рік публікації"}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                            <FormControl component="fieldset">
                                <FormLabel
                                    component="legend">{"Scopus"}</FormLabel>
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        value={work.isScopus}
                                        control={<Switch color="primary" checked={work.isScopus}
                                                         onChange={(event) => {
                                                             const value = event.target.checked;
                                                             setWork({
                                                                 ...work,
                                                                 isScopus: value
                                                             });
                                                         }}/>}
                                        label={work.isScopus ?
                                            "Так"
                                            : "Ні"}
                                        labelPlacement="right"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                            <FormControl component="fieldset">
                                <FormLabel
                                    component="legend">{"WoS"}</FormLabel>
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        value={work.isWoS}
                                        control={<Switch color="primary" checked={work.isWoS}
                                                         onChange={(event) => {
                                                             const value = event.target.checked;
                                                             setWork({
                                                                 ...work,
                                                                 isWoS: value
                                                             });
                                                         }}/>}
                                        label={work.isWoS ?
                                            "Так"
                                            : "Ні"}
                                        labelPlacement="right"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                            <FormControl component="fieldset">
                                <FormLabel
                                    component="legend">{"Copernicus"}</FormLabel>
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        value={work.isCopernicus}
                                        control={<Switch color="primary" checked={work.isCopernicus}
                                                         onChange={(event) => {
                                                             const value = event.target.checked;
                                                             setWork({
                                                                 ...work,
                                                                 isCopernicus: value
                                                             });
                                                         }}/>}
                                        label={work.isCopernicus ?
                                            "Так"
                                            : "Ні"}
                                        labelPlacement="right"
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl component="fieldset">
                                <FormLabel
                                    component="legend">{"Файл (зображення / PDF)"}</FormLabel>
                                <FormGroup aria-label="position" row>
                                    <FileUploader handleChange={async (file) => {
                                        const image = await getBase64FromFile(file);
                                        setWork({...work, image});
                                    }} name="file" types={fileTypes} maxSize={3}/>
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl fullWidth>
                                <InputLabel id="label-group">Група</InputLabel>
                                <Select
                                    labelId="label-group"
                                    id="select-group"
                                    label={"Група"}
                                    value={work.group}
                                    onChange={(e) => {
                                        const group = e.target.value;
                                        setWork({...work, group});
                                    }}
                                >
                                    <MenuItem
                                        value={"Наукові праці за профілем кафедри, опубліковані до захисту кандидатської дисертації"}>
                                        {"Наукові праці за профілем кафедри, опубліковані до захисту кандидатської дисертації"}
                                    </MenuItem>
                                    <MenuItem
                                        value={"Наукові праці за профілем кафедри, опубліковані після захисту кандидатської дисертації"}>
                                        {"Наукові праці за профілем кафедри, опубліковані після захисту кандидатської дисертації"}
                                    </MenuItem>
                                    <MenuItem value={"Авторські свідоцтва, дипломи, патенти"}>
                                        {"Авторські свідоцтва, дипломи, патенти"}
                                    </MenuItem>
                                    <MenuItem
                                        value={"Основні навчально-методичні праці (за період науково-педагогічної діяльності за профілем кафедри)"}>
                                        {"Основні навчально-методичні праці (за період науково-педагогічної діяльності за профілем кафедри)"}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{display: "flex", justifyContent: "flex-end"}}>
                        <Button onClick={addUserWork} variant={"contained"}>Додати</Button>
                    </Grid>
                </Grid>
            </Page>
        </ErrorBoundary>
    );
}

export default UserWorkAdd;
